var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6411 1.9441L12.5982 1.90493H12.5401H11.4601H11.4019L11.3589 1.94418L1.8339 10.6442L1.71802 10.75L1.82899 10.861L2.89399 11.926L2.99507 12.0271L3.10089 11.931L4.35006 10.7967V20.2349V20.2971L4.39399 20.341L5.14399 21.091L5.18793 21.1349H5.25006H9.75006H9.81219L9.85612 21.091L10.6061 20.341L10.6501 20.2971V20.2349V15.1349H13.3501V20.2349V20.2971L13.394 20.341L14.144 21.091L14.1879 21.1349H14.2501H18.7501H18.8122L18.8561 21.091L19.6061 20.341L19.6501 20.2971V20.2349V10.7845L20.9143 11.931L21.0201 12.027L21.1211 11.926L22.1861 10.861L22.2972 10.7499L22.1811 10.6441L12.6411 1.9441ZM8.89399 14.1289L8.85006 14.1728V14.2349V19.3349H6.15006V9.16083L12.0001 3.84749L17.8501 9.1519V19.3349H15.1501V14.2349V14.1728L15.1061 14.1289L14.3561 13.3789L14.3122 13.3349H14.2501H9.75006H9.68793L9.64399 13.3789L8.89399 14.1289Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon_home.ca0d5ee2405812dc92ecfd9587c6d1a8.svg";
export { ForwardRef as ReactComponent };